import Route from '@ember/routing/route';

export default class CoachingCoachSettingsAvailabilityRoute extends Route {
  queryParams = {
    calendarSyncError: {
      refreshModel: false,
    },
  };
}
